<script setup lang="ts">
import AddOrUpdateModelPricingDialog from '@/components/asicw/pricing/AddOrUpdateModelFamilyPricingDialog.vue'
import ViewLayout from '@/views/layouts/ViewLayout.vue'
import PricingTable from '@/components/asicw/pricing/PricingTable.vue'
import { ref } from 'vue'
import type { IMinerModelFamilyPricing } from '@/types/asicw/pricings'
import PricingHistoryDialog from '@/components/asicw/pricing/PricingHistoryDialog.vue'
import { Plus } from '@element-plus/icons-vue'
import { useOIDCStore } from '@/stores/oidc.store'

const { isASICWManagerUser } = useOIDCStore()
const addModelPricingDialogVisible = ref(false)
const historyDialogVisible = ref(false)

const pricingBeingEdited = ref<IMinerModelFamilyPricing>()
const pricingBeingVisualized = ref<IMinerModelFamilyPricing>()

const onEdit = (pricing: IMinerModelFamilyPricing) => {
  pricingBeingEdited.value = pricing
  addModelPricingDialogVisible.value = true
}

const onVisualize = (pricing: IMinerModelFamilyPricing) => {
  pricingBeingVisualized.value = pricing
  historyDialogVisible.value = true
}
</script>

<template>
  <ViewLayout>
    <template #controls>
      <el-button v-if="isASICWManagerUser" type="primary" :icon="Plus" @click="addModelPricingDialogVisible = true">
        Add Model Family
      </el-button>
    </template>
    <AddOrUpdateModelPricingDialog
      v-model="addModelPricingDialogVisible"
      :source="pricingBeingEdited"
      @close="pricingBeingEdited = undefined"
    />
    <PricingHistoryDialog
      v-if="pricingBeingVisualized?.id"
      v-model="historyDialogVisible"
      :pricing-id="pricingBeingVisualized.id"
      @closed="pricingBeingVisualized = undefined"
    />
    <PricingTable @edit="onEdit" @visualize="onVisualize" />
  </ViewLayout>
</template>
